module.exports = __webpack_public_path__ + "static/media/rectangle-wide.b9a56c44.svg";